import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AddContactComponent } from 'src/app/AddThings/add-contact/add-contact.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { DocusealHistoryComponent } from 'src/app/Others/docuseal-history/docuseal-history.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { EPF } from 'src/model/epf.model';
import { Profile } from 'src/model/profile.model';
import { ContactService } from 'src/services/contact.service';
import { DocusealService } from 'src/services/docuseal.service';

@Component({
	selector: 'app-customer-contact-list',
	templateUrl: './customer-contact-list.component.html',
	styleUrls: ['./customer-contact-list.component.scss'],
	standalone: false
})
export class CustomerContactListComponent implements OnInit, OnChanges {
	private router = inject(Router);
	private cdr = inject(ChangeDetectorRef);
	private restapi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	private contactService = inject(ContactService);
	protected sharedService = inject(SharedService);
	private docusealService = inject(DocusealService);
	protected enums = inject(Enums);

	@Input() viewCustomer: Customer;
	@Input() selectedProfile: Profile;
	@Input() epfDetails: EPF;

	customerContactList: Contact[] = [];

	ngOnInit() {
		// this.getContactInfo();
	}

	ngOnChanges() {
		if (this.customerContactList.length > 0) this.customerContactList.splice(0, this.customerContactList.length);
		this.getContactInfo();
	}

	getContactInfo() {
		// var xhttp = new XMLHttpRequest();
		// var url = "http://localhost:10080/api/v1/contacts?customerId=" + this.viewCustomerId;
		// xhttp.withCredentials = true;
		let index = 0;
		const xhttp = this.restapi.getRequest(this.constructApi.getCustomerContact(this.viewCustomer.ID));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					// create customer instance with all response data
					// let payment = new Payment(json.id, json.loanId, json.amount, json.date, json.accountId);

					const contact = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark);

					//add customer instance into customer list
					this.customerContactList.push(contact);
					this.getGuarantorFormExistence(contact, index);
					index++;
				});
			}
		};
	}

	downloadFile(filename: string, customerId: number) {
		const encoded = encodeURIComponent(filename);
		const xhr = this.restapi.getRequest(this.constructApi.getFullFile(customerId, encoded));
		xhr.responseType = 'blob';
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				if (xhr.status == 200) {
					this.sharedService.generateDownloadLink(xhr, filename);
				} else {
					this.sharedService.openAlert('Some error occurred. Please try again later', ALERT_TYPE.DANGER);
				}
			}
		};
	}

	getGuarantorFormExistence(contact: Contact, index: number) {
		const xhttp = this.restapi.getRequest(this.constructApi.getCustomerContactGuarantorFormExistence(this.viewCustomer.ID, contact.ID));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const result = Boolean(JSON.parse(xhttp.responseText));
				if (result == true) this.getContactGuarantorForm(contact, index);
			}
		};
	}

	private getContactGuarantorForm(contact: Contact, index: number) {
		const xhttp = this.restapi.getRequest(this.constructApi.getCustomerContactGuarantorForms(this.viewCustomer.ID, contact.ID));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					// let file = { label: json.Name, url: json.Data, contentType: json["Content-Type"] }

					this.customerContactList[index].GuarantorFilename = json.Name;
				});
			}
		};
	}

	openEditContactModal(contact: Contact) {
		const modalRef = this.sharedService.openModal(AddContactComponent);
		modalRef.componentInstance.viewCustomerId = this.viewCustomer.ID;
		modalRef.componentInstance.contactToUpdate = contact;
	}

	confirmBeforeDelete(contact: Contact) {
		const proceed = false;
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Confirm to delete contact ' + contact.Name + '?';

		modalRef.result.then(confirm => {
			if (confirm) this.deleteContact(contact.ID);
		});

		return proceed;
	}

	deleteContact(contactId: number) {
		const xhr = this.restapi.deleteRequest(this.constructApi.getDeleteContact(contactId));

		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.readyState == 4 && xhr.status == 200) {
					if (xhr.status == 200) {
						window.location.reload();
					} else {
						this.sharedService.openAlert('Opps, some errors occured. Please try again later', ALERT_TYPE.DANGER);
					}
				}
			}
		};
	}

	downloadGuarantorForm(contact: Contact) {
		const companyId = this.viewCustomer.CompanyId;
		this.router.navigateByUrl('/guarantorForm/' + companyId + '/' + this.viewCustomer.ID + '/' + contact.ID);
	}

	openAddContactModal() {
		const modalRef = this.sharedService.openModal(AddContactComponent);
		modalRef.componentInstance.viewCustomerId = this.viewCustomer.ID;

		//get added loan
		modalRef.componentInstance.passEntry.subscribe(entry => {
			const contact = entry;

			//append added loan to loan list
			this.customerContactList.push(contact);
		});

		modalRef.result.then(() => {
			//detect changes
			this.cdr.detectChanges();
		});
	}

	async openViewContactDocsModal(contactID: number) {
		const files = await this.contactService.getCustomerContactAllFiles(this.viewCustomer.ID, contactID);
		const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
		const i = modalRef.componentInstance as ThumbnailsListComponent;
		i.fileArr.set(files);
	}

	openUploadImageModal(contact: Contact, fileType: string) {
		const modalRef = this.sharedService.openModal(UploadImageComponent);

		modalRef.componentInstance.selectedCustomerId = this.viewCustomer.ID;
		modalRef.componentInstance.contactId = contact.ID;
		modalRef.componentInstance.contactDocType = fileType;

		modalRef.componentInstance.passEntry.subscribe(entry => {
			window.location.reload();
		});

		modalRef.result.then(() => {
			//detect changes
			this.cdr.detectChanges();
		});
	}

	async openViewDocusealHistory(contactId: number) {
		const dsList = await this.docusealService.getGuarantorDocuseals(this.viewCustomer.ID, contactId);
		const modalRef = this.sharedService.openModal(DocusealHistoryComponent);
		modalRef.componentInstance.dsList = dsList;
	}
}
